import Bowser from 'bowser';

import { ECheckoutPlatform, EOsSystem } from './types';

export const getOperatingSystem = (): EOsSystem => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const os = browser.getOSName().toUpperCase();

  if (os && Object.values(EOsSystem).includes(os as EOsSystem)) {
    return os as EOsSystem;
  }

  return EOsSystem.DESKTOP;
};

const OS_TO_CHECKOUT_PLATFORM: Record<EOsSystem, ECheckoutPlatform> = {
  [EOsSystem.DESKTOP]: ECheckoutPlatform.DESKTOP,
  [EOsSystem.IOS]: ECheckoutPlatform.IOS,
  [EOsSystem.ANDROID]: ECheckoutPlatform.ANDROID,
};

export const getCheckoutPlatform = (): ECheckoutPlatform => OS_TO_CHECKOUT_PLATFORM[getOperatingSystem()];
